import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { RadioButton } from 'Components';
import './BoolField.css';

const BoolField = props => (
  <div role="group" className="bool-field">
    { props.title && <div className="bool-field__title">{props.title}</div> }
    <span>
      <RadioButton text={i18n.t('common:Yes')} checked={props.checked} onClick={() => props.onClick(true)} />
      <RadioButton text={i18n.t('common:No')} checked={!props.checked && (!props.hasDefaultNone)} onClick={() => props.onClick(false)} />
    </span>
  </div>
);

BoolField.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  hasDefaultNone: PropTypes.bool,
};

BoolField.defaultProps = {
  checked: false,
  hasDefaultNone: false,
};

export default BoolField;



// WEBPACK FOOTER //
// ./src/components/BoolField/BoolField.jsx